import { render, staticRenderFns } from "./ManufacturerListingFields.vue?vue&type=template&id=13c3f24c&scoped=true"
import script from "./ManufacturerListingFields.vue?vue&type=script&lang=js"
export * from "./ManufacturerListingFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c3f24c",
  null
  
)

export default component.exports